// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `swiper[fxflex] {
  display: flex;
  flex-direction: inherit;
  min-width: 0;
  min-height: 0;
}

swiper[fxflex] > .swiper.s-wrapper {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  -webkit-box-flex: 1;
}

swiper > .swiper.s-wrapper {
  width: 100%;
  height: 100%;
}

swiper > .swiper.s-wrapper .swiper-wrapper .swiper-slide {
  will-change: transform;
  overflow: auto;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
}

swiper > .swiper.s-wrapper .swiper-pagination {
  pointer-events: none;
}

swiper > .swiper.s-wrapper .swiper-pagination .swiper-pagination-handle {
  position: relative;
  display: inline-block;
  padding: 4px;
  margin: 2px;
  cursor: pointer;
  pointer-events: all;
}

swiper > .swiper.s-wrapper .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet {
  display: inline-block;
  margin: 0;
  pointer-events: none;
}

swiper > .swiper.s-wrapper .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-last,
swiper > .swiper.s-wrapper .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-first {
  border: 1px solid rgba(0, 0, 0, 0.5);
}

swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-button-prev {
  top: 10px;
  left: 50%;
  margin-top: 0;
  margin-left: -13px;
  transform: rotate(90deg);
}

swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-button-next {
  top: auto;
  bottom: 10px;
  left: 50%;
  margin-top: 0;
  margin-left: -13px;
  transform: rotate(90deg);
}

.swiper-button-prev[hidden]::after, .swiper-button-next[hidden]::after {
  display: none;
}

swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-scrollbar {
  width: 8px;
  transition: width 250ms ease-in-out;
}

swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-scrollbar:hover {
  width: 16px;
}

swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-pagination .swiper-pagination-handle {
  display: block;
}

swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet {
  display: inline-block;
}

swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-last,
swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-first {
  margin: 0 -1px;
}

swiper > .swiper.s-wrapper.swiper-container-horizontal > .swiper-scrollbar {
  height: 8px;
  transition: height 250ms ease-in-out;
}

swiper > .swiper.s-wrapper.swiper-container-horizontal > .swiper-scrollbar:hover {
  height: 16px;
}

swiper > .swiper.s-wrapper.swiper-container-horizontal > .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-last,
swiper > .swiper.s-wrapper.swiper-container-horizontal > .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-first {
  margin: -1px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/swiper/swiper.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;AAGJ;;AAGE;EAGE,cAAA;EACA,YAAA;EACA,aAAA;EAEA,mBAAA;AAFJ;;AAKE;EACE,WAAA;EACA,YAAA;AAFJ;;AAKE;EACE,sBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAFJ;;AAKE;EACE,oBAAA;AAFJ;;AAKE;EACE,kBAAA;EAEA,qBAAA;EACA,YAAA;EACA,WAAA;EAEA,eAAA;EACA,mBAAA;AAJJ;;AAOE;EACE,qBAAA;EAEA,SAAA;EAEA,oBAAA;AANJ;;AASE;;EAEE,oCAAA;AANJ;;AASE;EACE,SAAA;EACA,SAAA;EAEA,aAAA;EACA,kBAAA;EAEA,wBAAA;AARJ;;AAWE;EACE,SAAA;EACA,YAAA;EACA,SAAA;EAEA,aAAA;EACA,kBAAA;EAEA,wBAAA;AAVJ;;AAaE;EACE,aAAA;AAVJ;;AAaE;EACE,UAAA;EAEA,mCAAA;AAXJ;;AAcE;EACE,WAAA;AAXJ;;AAcE;EACE,cAAA;AAXJ;;AAcE;EACE,qBAAA;AAXJ;;AAcE;;EAEE,cAAA;AAXJ;;AAcE;EACE,WAAA;EAEA,oCAAA;AAZJ;;AAeE;EACE,YAAA;AAZJ;;AAeE;;EAEE,cAAA;AAZJ","sourcesContent":["swiper[fxflex] {\r\n    display: flex;\r\n    flex-direction: inherit;\r\n    min-width: 0;\r\n    min-height: 0;\r\n  \r\n    -webkit-box-direction: inherit;\r\n    -webkit-box-orient: inherit;\r\n  }\r\n  \r\n  swiper[fxflex] > .swiper.s-wrapper {\r\n    -ms-flex: 1 1 auto;\r\n  \r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    min-height: 0;\r\n  \r\n    -webkit-box-flex: 1;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper .swiper-wrapper .swiper-slide {\r\n    will-change: transform;\r\n    overflow: auto;\r\n    width: 100%;\r\n    height: 100%;\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper .swiper-pagination {\r\n    pointer-events: none;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper .swiper-pagination .swiper-pagination-handle {\r\n    position: relative;\r\n  \r\n    display: inline-block;\r\n    padding: 4px;\r\n    margin: 2px;\r\n  \r\n    cursor: pointer;\r\n    pointer-events: all;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet {\r\n    display: inline-block;\r\n  \r\n    margin: 0;\r\n  \r\n    pointer-events: none;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-last,\r\n  swiper > .swiper.s-wrapper .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-first {\r\n    border: 1px solid rgba(0, 0, 0, 0.5);\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-button-prev {\r\n    top: 10px;\r\n    left: 50%;\r\n  \r\n    margin-top: 0;\r\n    margin-left: -13px;\r\n  \r\n    transform: rotate(90deg);\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-button-next {\r\n    top: auto;\r\n    bottom: 10px;\r\n    left: 50%;\r\n  \r\n    margin-top: 0;\r\n    margin-left: -13px;\r\n  \r\n    transform: rotate(90deg);\r\n  }\r\n  \r\n  .swiper-button-prev[hidden]::after,  .swiper-button-next[hidden]::after {\r\n    display: none;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-scrollbar {\r\n    width: 8px;\r\n  \r\n    transition: width 250ms ease-in-out;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-scrollbar:hover {\r\n    width: 16px;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-pagination .swiper-pagination-handle {\r\n    display: block;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet {\r\n    display: inline-block;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-last,\r\n  swiper > .swiper.s-wrapper.swiper-container-vertical > .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-first {\r\n    margin: 0 -1px;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper.swiper-container-horizontal > .swiper-scrollbar {\r\n    height: 8px;\r\n  \r\n    transition: height 250ms ease-in-out;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper.swiper-container-horizontal > .swiper-scrollbar:hover {\r\n    height: 16px;\r\n  }\r\n  \r\n  swiper > .swiper.s-wrapper.swiper-container-horizontal > .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-last,\r\n  swiper > .swiper.s-wrapper.swiper-container-horizontal > .swiper-pagination .swiper-pagination-handle .swiper-pagination-bullet.swiper-pagination-bullet-first {\r\n    margin: -1px 0;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
